"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_switch_1 = __importDefault(require("react-switch"));
var styled_components_1 = __importDefault(require("styled-components"));
var styled_components_2 = require("styled-components");
var Label = styled_components_1.default.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  cursor: ", ";\n  max-width: max-content;\n"], ["\n  display: flex;\n  cursor: ", ";\n  max-width: max-content;\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'default' : 'pointer');
});
Label.displayName = 'Label';
var Title = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 14px;\n  color: ", ";\n  margin-left: 9px;\n"], ["\n  font-size: 14px;\n  color: ", ";\n  margin-left: 9px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colours.switch.titleColor;
});
Title.displayName = 'Title';
var ToggleSwitch = function (_a) {
    var title = _a.title, checked = _a.checked, onChange = _a.onChange, disabled = _a.disabled, testID = _a.testID;
    var theme = react_1.useContext(styled_components_2.ThemeContext);
    var Element = (react_1.default.createElement(react_switch_1.default, { checked: checked, disabled: disabled, onChange: onChange, onColor: theme.colours.switch.activeBackground, onHandleColor: theme.colours.switch.handleColor, offColor: theme.colours.switch.inactiveBackground, offHandleColor: theme.colours.switch.inactiveHandle, handleDiameter: 14, uncheckedIcon: false, checkedIcon: false, height: 20, width: 44, className: "react-switch " + (testID ? testID : '') }));
    if (title) {
        return (react_1.default.createElement(Label, { disabled: disabled },
            Element,
            title && react_1.default.createElement(Title, null, title)));
    }
    return Element;
};
ToggleSwitch.displayName = 'ToggleSwitch';
exports.default = ToggleSwitch;
var templateObject_1, templateObject_2;
//# sourceMappingURL=toggle-switch.component.js.map